
$(document).ready(function () {


    $(document).scroll(setUpHeader);
    $(window).resize(setUpHeader);
    $(window).on("load",setUpHeader);


    function setUpHeader(e){
        var head = $('#head_banner');

            head.removeClass( "fixed-top",1000 );

            if($(window).width() <= 767 ){
                // $(".image-first-row-header").addClass("d-block").removeClass("d-none");
                // $(".image-second-row-header").addClass("d-none").removeClass("d-block");
                $(".first-row-header").removeClass("d-none").addClass("py-3");
                $(".second-row-header").addClass("d-none").removeClass("d-block").addClass("py-3");
            }else{
                // $(".image-first-row-header").addClass("d-block").removeClass("d-none");
                // $(".image-second-row-header").addClass("d-none").removeClass("d-block");
                $(".first-row-header").removeClass("py-3");
            }
        // }
    }








    // When the user scrolls the page, execute myFunction
    window.onscroll = function() {myFunction()};

// Get the navbar
    var navbar = document.getElementById("head_banner");

// Get the offset position of the navbar
    var sticky = navbar.offsetTop;

// Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function myFunction() {
        if (window.pageYOffset >= sticky) {
            navbar.classList.add("sticky_head_banner");
            $("#head").next().css("padding-top", 84);
        } else {
            navbar.classList.remove("sticky_head_banner");
            $("#head").next().css("padding-top", 0);
        }
    }
});
